<!-- =========================================================================================
    File Name: Register.vue
    Description: Register Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full vx-row no-gutter items-center justify-center">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
            <vx-card class="rounded">
                <div slot="no-body" class="rounded full-page-bg-color">
                    <div class="vx-row no-gutter no-gutter justify-center items-center">
                      <div class="vx-col hidden lg:block lg:w-1/2">
                        <a href="https://feedback.link">
                          <img v-if="provider === 'appsumo'" src="@/assets/images/logo/asfbl.png" alt="login" class="mx-auto w-64"/>
                          <img v-if="provider === 'pitchground'" src="@/assets/images/logo/pgfbl.png" alt="login" class="mx-auto w-64"/>
                          <img v-if="provider === 'dealify'" src="@/assets/images/logo/dfyfbl.png" alt="login" class="mx-auto w-64"/>
                        </a>
                      </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg rounded">
                            <div class="px-8 pt-8 register-tabs-container">
                              <div class="vx-card__title mb-4">
                                <img v-if="provider === 'appsumo'" src="@/assets/images/logo/asfbl.png" alt="login" class="mx-auto w-64 mt-6 mb-10 lg:hidden"/>
                                <img v-if="provider === 'pitchground'" src="@/assets/images/logo/pgfbl.png" alt="login" class="mx-auto w-64 mt-6 mb-10 lg:hidden"/>
                                <img v-if="provider === 'dealify'" src="@/assets/images/logo/dfyfbl.png" alt="login" class="mx-auto w-64 mt-6 mb-10 lg:hidden"/>                              
                          </div>  
                              <h1 v-if="provider === 'appsumo'" class="my-4 mb-6 font-medium text-center">Welcome, Sumoling!👋 </h1>
                                <h1 v-if="provider === 'pitchground'" class="my-4 mb-6 font-medium text-3xl text-center">Welcome, Pitchground customer! </h1>
                                <h1 v-if="provider === 'dealify'" class="my-4 mb-6 font-medium text-3xl text-center">Welcome, Dealify customer! </h1>
                                <p class="my-5 font-medium text-lg">Thank you for getting your Feedback Link lifetime deal!</p>                                
                                <p class="my-5">Let's start setting up your Feedback Link by creating your account.</p>
                                    <register-firebase :provider="provider"></register-firebase>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>

import RegisterFirebase from './RegisterFirebaseLTD.vue'


export default {
  data() {
    return {
      provider: false
    }
  },
  components: {
    RegisterFirebase
  },
  created() {
    if (
      typeof this.$route.params.provider === 'undefined' ||
      (
        this.$route.params.provider !== 'appsumo' &&
        this.$route.params.provider !== 'dealify' &&
        this.$route.params.provider !== 'pitchground'
      )
      ) this.$router.push('/dash/signup')

      this.provider = this.$route.params.provider

  }
}
</script>

<style lang="scss">
.register-tabs-container {
  min-height: 517px;

  .con-tab {
    padding-bottom: 23px;
  }
}
</style>
